export const successModalsMarkup = String.raw`<!-- AI Topic Generating Success Modal -->
<div class="modal-overlay" id="aiSuccessModal" style="z-index:201;">
  <div class="modal modal--sm">
    <div class="modal-body modal-result">
      <div class="modal-result-icon modal-result-icon--accent">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"></polyline></svg>
      </div>
      <h3 class="modal-result-title">Private topic is being created</h3>
      <p class="modal-result-description">AI is reading your sources and creating a private topic. You can follow its progress in AI Create.</p>

      <div class="modal-result-panel">
        <p class="modal-result-panel-title">What happens next?</p>
        <div class="modal-result-list">
          <div class="modal-result-step">
            <span class="modal-result-step-num">1</span>
            AI reads your reference links and source material
          </div>
          <div class="modal-result-step">
            <span class="modal-result-step-num">2</span>
            Creates structured chapters with read, listen, and watch modes
          </div>
          <div class="modal-result-step">
            <span class="modal-result-step-num modal-result-step-num--success">3</span>
            Topic appears in your AI Create list — ready to learn
          </div>
        </div>
      </div>

      <button class="btn btn-primary btn-lg w-full" data-proto-click="closeAiSuccess()">View on AI Create</button>
    </div>
  </div>
</div>

<!-- Idea Submitted Success Modal -->
<div class="modal-overlay" id="ideaSuccessModal">
  <div class="modal modal--sm">
    <div class="modal-body modal-result">
      <div class="modal-result-icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"></polyline></svg>
      </div>
      <h3 class="modal-result-title">Idea Submitted!</h3>
      <p class="modal-result-description">Your topic is now on the community board. Others can vote on it — the more votes, the faster it moves into production.</p>

      <div class="modal-result-panel">
        <p class="modal-result-panel-title">What happens next?</p>
        <div class="modal-result-list">
          <div class="modal-result-step">
            <span class="modal-result-step-num">1</span>
            Community members vote on your topic
          </div>
          <div class="modal-result-step">
            <span class="modal-result-step-num">2</span>
            Top-voted topics move to "In Progress"
          </div>
          <div class="modal-result-step">
            <span class="modal-result-step-num modal-result-step-num--success">3</span>
            Completed topics enter Browse, Home, and free previews
          </div>
        </div>
      </div>

      <button class="btn btn-primary btn-lg w-full" data-proto-click="closeIdeaSuccess()">View on Community Board</button>
    </div>
  </div>
</div>

`;
